import { configureStore } from '@reduxjs/toolkit';
import {thunk} from 'redux-thunk';
import adminReducer from './Reducers/adminReducer';
const store = configureStore({
  reducer: {
    admin:adminReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
